import {action, observable, runInAction} from 'mobx'
import {json} from '../../../../utils/ajax'
import {message} from 'antd'
import {setStore} from "../../../../utils/Utils";

class productIndex {

  @observable recommended
  @observable goods
  @observable menu
  @observable menu_level1
  @observable menu_level2
  @observable loading
  @observable menu_level1_title
  @observable menu_level2_title
  @observable menu_level2_id
  @observable goodsList
  @observable activityList
  @observable carseriesList
  @observable search
  @observable carSeriesList   //下拉的车系列表数据
  @observable carSeriesLevel1List    //选择车系后出来的1级列表
  @observable carSeriesId    //下拉框里面的车系Id
  @observable carSeriesLevel2List   //2级目录
  @observable carSeriesFootList  //底部车系卡片
  @observable isShowIconId
  @observable currencyCarseries   //通用车系图片展示
    @observable defaultValue

  constructor() {
    this.loading = false
    this.menu = []
    this.menu_level2 = []
    this.menu_level1_title = '';
    this.menu_level2_title = '';
    this.menu_level2_id = '';
    this.goods = []
    this.goodsList = []
    this.recommended = []
    this.activityList = []
    this.carseriesList = []
    this.search = ''
    this.carSeriesList = []
    this.carSeriesLevel1List = []
    this.carSeriesId = ''
    this.carSeriesLevel2List = []
    this.carSeriesFootList = []
    this.isShowIconId = ''
    this.currencyCarseries = []
      this.defaultValue = ''
  }

  /**调用setStore方法并传入当前this***/
  @action
  setStore = (obj) => {
    setStore(obj, this)
  }

  //初始化
  @action
  initMenu = async (e) => {
    if (e === "" || e === undefined) {
      const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/goods/generalMerchandise`)
      runInAction(()=> {
        if (res.status===0) {
          return
        }
        this.carSeriesFootList = Array.isArray(res)?res:[]
      })
    } else {
      const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/carCatalogProducts/productList`,{
        carId: this.carSeriesId,
        name: '',
        typeId: '',
      })
      runInAction(()=> {
        if (res.status===0) {
          return
        }
        this.carSeriesFootList = Array.isArray(res)?res:[]
      })
    }
  }
  //选择二级目录
  @action
  selectlevel2 = (id) => {
    this.isShowIconId = id
    this.carSeriesLevel2List = []
    this.carSeriesLevel1List.map(i=> {
      if (i.children&&i.children.length>0) {
        i.children.map(j=> {
          if (j.pId===id) {
            this.carSeriesLevel2List.push(j)
          }
        })
      }
    })
  }
  //筛选过后显示的底部列表卡片
  @action
  showGoodsList = async (id, name) => {
    const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/carCatalogProducts/productList`,{
      carId: this.carSeriesId,
      name: '',
      typeId: id
    })
    runInAction(()=> {
      if (res.status===0) {
        return
      }
     this.carSeriesFootList = Array.isArray(res)?res:[]
    })
  }
  //通过车系查列表
  @action
  showListByCarseries = async (carseries) => {
    runInAction(() => {
      this.loading = true;
    })
    let list = []
    if (this.menu_level2_id === '') {
      list = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/goods/boutiqueSearch?carseries=${carseries}&name=${this.search}`)
    } else {
      list = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/goods/receptionTypeIdQueryGoods?carseries=${carseries}&id=${this.menu_level2_id}`)
    }
    if (list && list.status === 0) {
      runInAction(() => {
        this.loading = false;
      })
      return
    }
    runInAction(() => {
      this.loading = false;
      this.goodsList = list
    })
  }
  //搜索的方法
  @action
  onSearch = async (value) => {
    runInAction(() => {
      this.loading = true;
      this.search = value;
    })
    const list = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/carCatalogProducts/frontDeskSearch`, {
      name: value?value:'',
    })
    if (list && list.status === 0) {
      runInAction(() => {
        this.loading = false;
      })
      return
    }
    if (list.length === 0) {
      message.warning('未找到数据');
      runInAction(() => {
        this.carSeriesFootList = list;
        this.loading = false;
      })
      return
    }
    const arr = this._getcarseriesList(list)
    runInAction(() => {
      this.carSeriesFootList = list
      this.carseriesList = arr;
      this.loading = false;
        if (value==='') {
            this.getFirstLevelList(this.carSeriesList[0].carseriesId)
            this.initMenu();
        }
    })
  }

  //获取车系列表
  @action
  _getcarseriesList(temp) {
    let arr = [] //车系数组
    for (let i = 0; i < temp.length; i++) {
      if (arr.indexOf(temp[i].carseries) === -1) {
        arr.push(temp[i].carseries)
      }
    }
    return arr;
  }

  @action
  getCarSeries = async () => {
    const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/carseriesCatalog/carseriesTable`)
    const res1 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/goods/generalMerchandise`)
    runInAction(() => {
      if (res.status === 0||res1.status === 0) {
        return
      }
      if (Array.isArray(res)) {
        this.carSeriesList = res
      } else {
        this.carSeriesList = []
      }
      res1.map(i=> {
        if(i.imgUrl !== '') {
          this.currencyCarseries.push(i)
          return this.currencyCarseries
        }
      })
    })
  }

  @action
  getFirstLevelList = async (id) => {
    this.carSeriesLevel1List = []
    this.carSeriesId = id
    const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/carCatalogProducts/carId`, {carId: id})
    runInAction(() => {
      if (res.status === 0) {
        return
      }
      this.carSeriesLevel1List = Array.isArray(res) ? res : []
      this.isShowIconId = ''
      this.initMenu(id)
    })
  }

  @action
  onFieldsChange = () => {}
}

export default new productIndex()


// WEBPACK FOOTER //
// ./src/project/dongfeng/products/Main/store.js